import React, { Component } from "react";

import { withStyles } from "@material-ui/core/styles";

import $ from "jquery";

import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Input,
  Badge,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Paper,
  Typography
} from "@material-ui/core";
import {
  CheckBoxOutlined,
  CheckBoxOutlineBlankOutlined
} from "@material-ui/icons";

const styles = theme => ({
  mainRequest: {
    display: "flex",
    flexDirection: "column",
    padding: ".5rem",
    flexGrow: 1
  },
  paperCls: {
    padding: "0rem .5rem",
    display: "flex",
    flexDirection: "column"
  },
  textField: {
    marginTop: "1rem"
  },
  formControl: {
    marginTop: "1.5rem"
  },
  mb1: {
    marginBottom: "1.5rem"
  },
  approvalButton: {
    marginRight: ".5rem",
    backgroundColor: "#3e733e"
  },
  declineButton: {
    backgroundColor: "rgba(135, 6, 0, 0.78)"
  },
  mr_5: {
    marginRight: ".25rem"
  },
  showNone: {
    display: "none !important",
    //   visibility: "hidden",
    transition: "all .5s  ease-in"
  },
  dflex: {
    display: "flex"
  },
  flexCol: {
    flexDirection: "column"
  },
  showApproveMsg: {
    margin: "4.5rem 0",
    padding: ".5rem"
    //   transition: "all .1s ease-in"
  },
  approvalText: {
    color: "#5a5757"
  }
});

class NteApprovalForm extends Component {
  constructor() {
    super();

    this.state = {
      isProd: true,
      approved: true
    };
  }

  componentWillMount = () => {};


  handleApproval = approval => {

    this.setState({
      approved: approval
    }, () => this.handlePropsApprovalUpdate(approval));

  };

  handlePropsApprovalUpdate = (approval) =>{
      console.log(this.props);
     this.props.propertyChangedEvent("approved", approval)
  }
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.mainRequest}>
        <div>
          <Button
            onClick={() => this.handleApproval(true)}
            color="primary"
            variant="contained"
            className={classes.approvalButton}
            size="large"
          >
            {this.state.approved ? (
              <CheckBoxOutlined className={classes.mr_5} />
            ) : (
              <CheckBoxOutlineBlankOutlined className={classes.mr_5} />
            )}
            Approve
          </Button>

          <Button
            onClick={() => this.handleApproval(false)}
            color="primary"
            variant="contained"
            className={classes.declineButton}
            size="large"
          >
            {!this.state.approved ? (
              <CheckBoxOutlined className={classes.mr_5} />
            ) : (
              <CheckBoxOutlineBlankOutlined className={classes.mr_5} />
            )}
            Decline
          </Button>
        </div>

        <div
          className={[
            this.state.approved ? classes.showNone : null,
            classes.dflex,
            classes.flexCol
          ].join(" ")}
        >
          <TextField
            label="First Name"
            className={[classes.descriptionItem, classes.mr1].join(" ")}
            onChange={evt =>
              this.props.propertyChangedEvent("firstName", evt.target.value)
            }
            margin="normal"
          />
          <TextField
            label="Last Name"
            className={[classes.lastName, classes.mr1].join(" ")}
            onChange={evt =>
              this.props.propertyChangedEvent("lastName", evt.target.value)
            }
            margin="normal"
          />

          <TextField
            label="Decline Reason"
            multiline
            rowsMax="6"
            onChange={evt =>
              this.props.propertyChangedEvent("declineReason", evt.target.value)
            }
            className={[classes.mr1].join(" ")}
            margin="normal"
          />
        </div>

        <div
          className={[
            this.state.approved ? classes.showApproveMsg : classes.showNone
          ].join(" ")}
        >
          <Typography
            variant="h4"
            gutterBottom
            align="center"
            className={classes.approvalText}
          >
            Thanks for approving the NTE.
          </Typography>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(NteApprovalForm);
